<template>
	<div class="service no-trans" v-loading="loading">
        <div class="banners">
            <img src="../../../assets/img/index/services/banner.png" alt="">
        </div>
        <div class="service_box">
            <div class="type_list">
                <div class="type_item" v-for="(item,index) in type_list" :key="index" :class="{type_ac:item.type==type_ac}" role="button" :aria-pressed="item.type==type_ac" tabindex="0" @keydown.enter.prevent="handle_type(item)" @keydown.space.prevent="handle_type(item)" @click="handle_type(item)">
                    <div class="items">
                        <div class="item_img">
                            <img :src="item.imgs" alt="">
                        </div>
                        <div class="item_info">
                            <div class="item_title">{{ item.title }}</div>
                            <div class="item_text">{{ item.text }}</div>
                        </div>
                    </div>
                    <div class="type_borders" v-if="index<2"></div>
                </div>
            </div>
            <div class="type_box" v-if="type_ac==1">
                <div class="type_lefts">
                    <div class="left_title">填写信息</div>
                    <div class="form_flex">
                        <div class="form_title"><span>*</span>费用类型</div>
                        <div class="form_input1">
                            <el-select v-model="Lawsui_form.caseType" placeholder="请选择" @change="change_caseType">
                                <el-option
                                v-for="(item,index) in calculateLawsuiCaseType_list"
                                :key="index"
                                :label="item.title"
                                :value="item.id">
                                </el-option>
                            </el-select>
                        </div>
                    </div>
                    
                    <div class="form_flex">
                        <div class="form_title"><span>*</span>诉讼标的</div>
                        <div class="form_input2">
                            <el-input v-model="Lawsui_form.amount" inputmode="decimal" placeholder="请填写金额（单位：元）">
                                <div slot="suffix">元</div>
                            </el-input>
                        </div>
                    </div>
                    <div class="form_flex">
                        <div class="form_title"></div>
                        <div class="form_input3">
                            <div class="btns1" role="button" tabindex="0" @keydown.enter.prevent="handle_calculateLawsuiCost" @click="handle_calculateLawsuiCost">马上计算</div>
                            <div class="btns2" role="button" tabindex="0" @keydown.enter.prevent="handle_calculateLawsuiCost_clear" @click="handle_calculateLawsuiCost_clear">重新计算</div>
                        </div>
                    </div>
                </div>
                <div class="type_border"></div>
                <div class="type_rights">
                    <div class="price_title">计算结果</div>
                    <div class="price_box1" aria-live="polite">
                        <span class="span1">{{ calculateLawsuiCasePrice }}</span>
                        <span class="span2">元</span>
                    </div>
                    <div class="price_box2">
                        <div class="text1">服务类型</div>
                        <div class="text2">{{ calculateLawsuiCase.title }}</div>
                    </div>
                    <div class="price_box3">
                        <div class="text1">计算方式</div>
                        <div class="text2">
                            依据
                            <span @click="handle_ag(123)">人民法院诉讼费缴费标准及计算公式（2024）</span>
                            计算
                        </div>
                    </div>
                    <div class="price_box4">
                        温馨提示：预估价格仅供参考<span @click="handle_ag(123)">《计算标准说明》</span>
                    </div>
                </div>
            </div>
            <div class="type_box" v-if="type_ac==2">
                <div class="type_lefts">
                    <div class="left_title">填写信息</div>
                    <div class="form_flex">
                        <div class="form_title"><span>*</span>服务类型</div>
                        <div class="form_input1">
                          
                            <el-select v-model="Servicet_form.feeType" placeholder="请选择">
                                <el-option
                                v-for="(item,index) in calculateServicetFeeType_list"
                                :key="index"
                                :label="item.title"
                                :value="item.id">
                                </el-option>
                            </el-select>
                        </div>
                    </div>
                    <div class="form_flex">
                        <div class="form_title"><span>*</span>服务事项</div>
                        <div class="form_input1">
                            <el-select v-model="Servicet_form.caseType" placeholder="请选择" @change="change_caseType_Servicet_form">
                                <el-option
                                v-for="(item,index) in calculateServicetCaseType_list"
                                :key="index"
                                :label="item.title"
                                :value="item.id">
                                </el-option>
                            </el-select>
                        </div>
                    </div>
                    <div class="form_flex">
                        <div class="form_title"><span>*</span>诉讼标的</div>
                        <div class="form_input2">
                            <el-input v-model="Servicet_form.amount" placeholder="请填写金额（单位：元）">
                                <div slot="suffix">元</div>
                            </el-input>
                        </div>
                    </div>
                    <div class="form_flex" v-if="Servicet_form.feeType==1">
                        <div class="form_title"><span>*</span>时间</div>
                        <div class="form_input2">
                            <el-input v-model="Servicet_form.hours" placeholder="请填写时间（单位：小时）">
                                <div slot="suffix">小时</div>
                            </el-input>
                        </div>
                    </div>
                    <div class="form_flex">
                        <div class="form_title"></div>
                        <div class="form_input3">
                            <div class="btns1" @click="handle_calculateServicetCost">马上计算</div>
                            <div class="btns2">重新计算</div>
                        </div>
                    </div>
                </div>
                <div class="type_border"></div>
                <div class="type_rights">
                    <div class="price_title">计算结果</div>
                    <div class="price_box1">
                        <span class="span1">{{ calculateServicetFeePrice }}</span>
                        <span class="span2">元</span>
                    </div>
                    <div class="price_box2">
                        <div class="text1">服务类型</div>
                        <div class="text2">{{ calculateServicetCase.title }}</div>
                    </div>
                    <div class="price_box3">
                        <div class="text1">计算方式</div>
                        <div class="text2">
                            依据
                            <span  @click="handle_ag(122)">关于广东律师事务所律师服务费标准（意见）</span>
                            计算
                        </div>
                    </div>
                    <div class="price_box4">
                        温馨提示：预估价格仅供参考<span @click="handle_ag(122)">《计算标准说明》</span>
                    </div>
                </div>
            </div>
            <div class="type_box2"  v-if="type_ac==3">
                <table border class="type_table">
                    <tr class="type_header">
                        <td class="td1">服务项目</td>
                        <td class="td2">费用</td>
                    </tr>
                    <tr class="table_list" v-for="(item,index) in fwfy_list" :key="index" :class="{table_list_color:(index+1)%2==0}">
                        <td>{{ item.title }}</td>
                        <td>{{ item.price }}</td>
                    </tr>
                </table>
            </div>
            <div class="ls_box" v-if="!mobile_view || vuex_lawyers.length">
                <div class="title_box">
                   <div class="text_box">
                        <div class="title_text1">精英律师</div>
                        <div class="title_text2">
                            ELITE LAWYER
                            <img src="@/assets/img/index/home/right1.png" alt="">
                        </div>
                   </div>
                   <div class="title_btns">
                        <div class="btns">了解更多+</div>
                   </div>
                </div>
                <div class="ls_list">
                    <div class="item" v-for="(item, index) in vuex_lawyers" :key="index" v-if="index<3" @click="handle_ls_path(item)">
                        <div class="item_left">
                            <div class="item_left_tops">
                                <div class="item_title">{{ item.name }}</div>
                                <div class="item_firm">{{item.work_company}}</div>
                                <div class="item_tage">{{ minx_get_causeIds(item.causeIds) }}</div>
                            </div>
                            <div class="item_left_boms">
                                <div class="btns1">立即咨询</div>
                            </div>
                        </div>
                        <div class="item_right">
                            <!-- <img src="../../../assets/img/index/home/lsimg.png" alt=""> -->
                             <img :src="item.business_img" alt="">
                        </div>
                    </div>
                </div>
            </div>
            <div class="tjfw_box" v-if="!mobile_view || list.length">
                <div class="title_box">
                   <div class="text_box">
                        <div class="title_text1">推荐服务</div>
                        <div class="title_text2">
                            RECOMMENDED SERVICES
                            <img src="@/assets/img/index/home/right1.png" alt="">
                        </div>
                   </div>
                   <div class="title_btns">
                        <div class="btns">了解更多+</div>
                   </div>
                </div>
                <div class="tjfw_list">
                    <div class="item" v-for="(item,index) in list" :key="index" @click="handle_sever_path(item)">
                        <div class="item_img">
                            <!-- <img src="../../../assets/img/index/legal/bg1.png" alt=""> -->
                             <img :src="item.thumb" alt="">
                        </div>
                        <div class="item_info">
                            <div class="item_title">{{ item.title }}</div>
                            <div class="item_tages">
                                <div class="tages" v-if="item.cate1">{{ item.cate1.title }}</div>
                                <div class="tages" v-if="item.cate2">{{ item.cate1.title }}</div>
                                <div class="tages" v-if="item.cate3">{{ item.cate1.title }}</div>
                            </div>
                            <div class="item_price">
                                <div class="prices"> ￥{{ item.price }}</div>
                                <div class="nums">销量 {{ item.sale_num }}</div>
                            </div>
                        </div>
                       
                    </div>
                    <div class="item2" v-for="(item,index) in 4" ></div>
                </div>
            </div>
        </div>
        <!-- <pop ref="pop"></pop> -->
        <agreement ref="agreement"  @handle_end="handle_end"></agreement>

	</div>
</template>
<script>
	import {
		mapState
	} from 'vuex'
    import pop from '@/components/More_services/pop.vue'//提交评论
    import agreement from '../../agreement2.vue'//提交评论

    
	export default {
		components: {
            pop,
            agreement
		},
		name: "index",
		data() {
			return {
				loading:false,
                type_ac:1,
                type_list:[
                    {
                        imgs:require('../../../assets/img/index/services/icon1.png'),
                        title:'诉讼费计算器',
                        text:'文案简短描述',
                        type:1,
                    },
                    {
                        imgs:require('../../../assets/img/index/services/icon2.png'),
                        title:'服务报价计算器',
                        text:'文案简短描述',
                        type:2,
                    },
                    {
                        imgs:require('../../../assets/img/index/services/icon3.png'),
                        title:'点评服务费',
                        text:'文案简短描述',
                        type:3,
                    },
                ],
                form:{
                    title:'',
                },
                options: [{
                    value: '选项1',
                    label: '黄金糕'
                },],
                list:[],
                // 诉讼
                calculateLawsuiCaseType_list:[],
                calculateLawsuiCase:{},
                // 提交数据
                Lawsui_form:{
                    caseType:'',
                    amount:'',
                },
                calculateLawsuiCasePrice:0,

                // 服务
                calculateServicetFeeType_list:[],
                calculateServicetFee:{},
                calculateServicetCaseType_list:[],
                calculateServicetCase:{},
                //提交数据
                Servicet_form:{
                    feeType:'',//费用类型
                    caseType:'',// 案件类型 ,
                    amount:'',// 金额 ,
                    hours:'',// 小时
                },
                calculateServicetFeePrice:0,

                 
			}
		},
		computed: {
			...mapState(['vuex_lawyers', 'vuex_setting']),
            fwfy_list(){
                let list=[
                    {
                        title:'初级点评服务费',
                        price:this.vuex_setting.level1,
                    },
                    {
                        title:'中级点评服务费',
                        price:this.vuex_setting.level2,
                    },
                    {
                        title:'高级点评服务费',
                        price:this.vuex_setting.level3,
                    },{
                        title:'特级点评服务费',
                        // price:this.vuex_setting.level4,
                        price:'面议',

                    }
                ]

                return list
            },
		},
		watch: {
            $route: {
				handler(newVal, oldVal) {
					// this.get_user()
                    const type = Number(this.$route.query.type)
                    this.type_ac = [1, 2, 3].includes(type) ? type : 1

				},
				immediate: true,
				deep: true
			},
		},
		created() {
            this.get_sever()
            this.get_calculateLawsuiCaseType()
            this.get_calculateServicetFeeType()
            this.get_calculateServicetCaseType()
			 
		},
		methods: {
            handle_ag(id){
                this.$refs.agreement.get_detial(id)
            },
            // 诉讼费用
            get_calculateLawsuiCaseType(){
                this.$api("calculateLawsuiCaseType", {

                }, "get").then((res) => {
                    console.log('诉讼费用-案件类型',res)
                    if (res.code == 1) {
                        this.calculateLawsuiCaseType_list=res.data
                    } else {
                        alertErr(res.msg)
                    }
                });

            },
            change_caseType(id){
                this.calculateLawsuiCaseType_list.forEach(item=>{
                    if(item.id==id){
                        this.calculateLawsuiCase=item
                    }
                })
                this.calculateLawsuiCasePrice=0
                
            },
            handle_calculateLawsuiCost(){
                if(!this.Lawsui_form.caseType){
                    alertErr('请选择案件类型')
                    return
                }
                if(!this.Lawsui_form.amount){
                    alertErr('请输入金额')
                    return
                }
                this.$api("calculateLawsuiCost", {
                    caseType:this.Lawsui_form.caseType,
                    amount:this.Lawsui_form.amount,
                }, "get").then((res) => {
                    console.log('诉讼费用-案件类型',res)
                    if (res.code == 1) {
                        this.calculateLawsuiCasePrice=res.data.fee
                    } else {
                        alertErr(res.msg)
                    }
                });

            },
            handle_calculateLawsuiCost_clear(){
                this.calculateLawsuiCase={}
                this.Lawsui_form={
                    caseType:'',
                    amount:'',
                }
                this.calculateLawsuiCasePrice=0
            },
            // 服务雷
            get_calculateServicetFeeType(){
                this.$api("calculateServicetFeeType", {

                }, "get").then((res) => {
                    console.log('服务费用-服务类型',res)
                    if (res.code == 1) {
                        this.calculateServicetFeeType_list=res.data
                    } else {
                        alertErr(res.msg)
                    }
                });
            },
            get_calculateServicetCaseType(){
                this.$api("calculateServicetCaseType", {

                }, "get").then((res) => {
                    console.log('服务费用-服务事项',res)
                    if (res.code == 1) {
                        this.calculateServicetCaseType_list=res.data
                    } else {
                        alertErr(res.msg)
                    }
                });
            },
            change_caseType_Servicet_form(id){
                this.calculateServicetCaseType_list.forEach(item=>{
                    if(item.id==id){
                        this.calculateServicetCase=item
                    }
                })
                this.calculateServicetFeePrice=0
            },
            handle_calculateServicetCost(){

                if(!this.Servicet_form.feeType){
                    alertErr('请选择服务类型')
                    return
                }
                if(!this.Servicet_form.caseType){
                    alertErr('请选择服务事项')
                    return
                }
                if(!this.Servicet_form.amount){
                    alertErr('请输入金额')
                    return
                }
                if(!this.Servicet_form.hours&&this.Servicet_form.feeType==1){
                    alertErr('请输入时间')
                    return
                }
                this.$api("calculateServicetCost", {
                     ...this.Servicet_form,
                }, "get").then((res) => {
                    console.log('诉讼费用-案件类型',res)
                    if (res.code == 1) {
                        this.calculateServicetFeePrice=res.data.fee
                    } else {
                        alertErr(res.msg)
                    }
                });
            },


            handle_type(item){
                this.type_ac=item.type
            },
            get_sever(){
                this.$api("servePros", {
                    limit:4,
                }, "get").then((res) => {
                    this.loading = false
                    console.log('服务列表',res)
                    if (res.code == 1) {
                        this.list=res.data.data
                    } else {
                        alertErr(res.msg)
                    }
                });
                
            },
            handle_ls_path(item){
                this.$router.push({
                    path:'/lawyer_detial',
                    query:{
                        id:item.id
                    }
                })
            },
            handle_sever_path(item){
                if(item.type==1){
                    this.$router.push({
                        path:'/individual_detial',
                        query:{
                            id:item.id
                        }
                    })
                }else{
                    this.$router.push({
                        path:'/enterprise_detial',
                        query:{
                            id:item.id
                        }
                    })
                }
            },

		},

	}
</script>
<style scoped lang="less">
	.service {
        width: 100%;
        background-color: #fff;
        padding-bottom: 100px;
        .banners{
            position: relative;
            z-index: 1;
            width: 100%;
            height: 320px;
            img{
                width: 100%;
                height: 320px;
            }
        }
        .service_box{
            width: 1440px;
            margin: auto;
            position: relative;
            z-index: 2;
            .type_list{
                width: 1372px;
                height: 180px;
                background: #FFFFFF;
                box-shadow: 2px 2px 10px 1px rgba(1,9,46,0.1);
                border-radius: 8px 8px 8px 8px;
                // border-radius: 20px;
                overflow: hidden;
                margin: auto;
                margin-top: -90px;
                display: flex;
                align-items: center;
                justify-content: space-between;
                .type_item{
                    display: flex;
                    align-items: center;
                    cursor: pointer;
                    .items{
                        width: 457px;
                        height: 180px;
                        // background-color: red;
                        border-bottom:6px solid #fff;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        .item_img{
                            width: 48px;
                            img{
                                width: 48px;
                            }
                        }
                        .item_info{
                            padding-left: 24px;
                            .item_title{
                                font-family: Microsoft YaHei, Microsoft YaHei;
                                font-weight: 400;
                                font-size: 20px;
                                color: #333333;
                            }
                            .item_text{
                                font-family: Microsoft YaHei, Microsoft YaHei;
                                font-weight: 400;
                                font-size: 14px;
                                color: #999999;
                                margin-top: 12px;
                            }
                        }

                    }
                    .type_borders{
                        width: 1px;
                        height: 56px;
                        background: #D7D7D7;
                        // box-shadow: 2px 2px 10px 1px rgba(1,9,46,0.1);
                        // border-radius: 4px 4px 4px 4px;
                    }
                    &:hover{
                        .items{
                            border-bottom:6px solid #377CFD;

                        }
                    }
                }
                .type_ac{
                    .items{
                        border-bottom:6px solid #377CFD;

                    }
                }
            }
            .type_box{
                display: flex;
                // align-items: center;
                justify-content: space-between;
                margin-top: 64px;
                .type_lefts{
                    flex: 1;
                    padding-top: 16px;

                    // padding: 0 110px;
                    .left_title{
                        text-align: center;
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: 400;
                        font-size: 20px;
                        color: #333333;
                        margin-bottom: 40px;
                    }
                    .form_flex{
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        margin-bottom: 24px;
                        .form_title{
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: 400;
                            font-size: 14px;
                            color: #999999;
                            padding-right: 24px;
                            width: 100px;
                            text-align: right;
                            span{
                                color: #FD4C5C;
                            }
                        }
                        .form_input1{
                            width: 400px;

                            /deep/.el-select{
                                width: 400px;
                            }
                        }
                        .form_input2{
                            width: 400px;
                            /deep/.el-input{
                                .el-input__inner{
                                    // padding-right: 40px
                                    // width: 360px;

                                }
                                .el-input__suffix{
                                    padding:0 5px;
                                    // width: 40px;
                                    display: flex;
                                    align-items: center;
                                }
                            }
                        }
                        .form_input3{
                            display: flex;
                            align-items: center;
                            margin-top: 56px;
                            .btns1{
                                width: 134px;
                                height: 40px;
                                background: #377CFD;
                                border-radius: 4px 4px 4px 4px;
                                border: 1px solid #377CFD;
                                text-align: center;
                                line-height: 40px;
                                cursor: pointer;
                                font-family: Microsoft YaHei, Microsoft YaHei;
                                font-weight: bold;
                                font-size: 14px;
                                color: #FFFFFF;
                            }
                            .btns2{
                                width: 134px;
                                height: 40px;
                                background: #FFFFFF;
                                border-radius: 4px 4px 4px 4px;
                                border: 1px solid #377CFD;
                                text-align: center;
                                line-height: 40px;
                                cursor: pointer;
                                font-family: Microsoft YaHei, Microsoft YaHei;
                                font-weight: bold;
                                font-size: 14px;
                                color: #377CFD;
                                margin-left: 10px;
                            }

                        }
                        
                    }
                }
                .type_border{
                    width: 1px;
                    height: 440px;
                    background: #D1D9E1;
                    // box-shadow: 2px 2px 10px 1px rgba(1,9,46,0.1);
                    border-radius: 4px 4px 4px 4px;
                }
                .type_rights{
                    padding-top: 16px;
                    flex: 1;
                    .price_title{
                        text-align: center;
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: 400;
                        font-size: 20px;
                        color: #333333;
                        margin: auto;
                    }
                    .price_box1{
                        width: 490px;
                        height: 114px;
                        background: rgba(55,124,253,0.04);
                        border-radius: 4px 4px 4px 4px;
                        margin: auto;
                        margin-top: 40px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        .span1{
                          
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: bold;
                            font-size: 40px;
                            color: #377CFD;

                        }
                        .span2{
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: bold;
                            font-size: 24px;
                            color: #377CFD;
                            margin-left: 10px;
                        }
                    }
                    .price_box2{
                        width: 490px;
                        height: 40px;
                        background: rgba(55,124,253,0.04);
                        border-radius: 4px 4px 4px 4px;
                        margin: auto;
                        margin-top: 16px;
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                        padding: 0 16px;
                        .text1{
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: 400;
                            font-size: 14px;
                            color: #666666;
                        }
                        .text2{
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: 400;
                            font-size: 14px;
                            color: #333333;
                        }

                    }
                    .price_box3{
                        width: 490px;
                        height: 40px;
                        background: rgba(55,124,253,0.04);
                        border-radius: 4px 4px 4px 4px;
                        margin: auto;
                        margin-top: 16px;
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                        padding: 0 16px;
                        .text1{
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: 400;
                            font-size: 14px;
                            color: #666666;
                        }
                        .text2{
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: 400;
                            font-size: 14px;
                            color: #333333;
                            span{
                               color: #377CFD; 
                               cursor: pointer;
                            }
                        }

                    }
                    .price_box4{
                        width: 490px;
                        margin: auto;
                        margin-top: 16px;
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: 400;
                        font-size: 12px;
                        color: #999999;
                        span{
                            color: #377CFD;
                            cursor: pointer;
                        }
                    }
                }
            }
            .type_box2{
                width: 1200px;
                margin: auto;
                margin-top:65px;
                margin-bottom: 80px;
                .type_table{
                    border-collapse: collapse;
                    .type_header{
                        text-align: center;
                        border-color: #D7D7D7;
                        .td1{
                            width: 360px;
                            height: 48px;
                            background: #D0D8E6;
                            border-radius: 0px 0px 0px 0px;
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: bold;
                            font-size: 16px;
                            color: #000000;
                            border-right: 1px solid #EBEEF5;
                        }
                        .td2{
                            width: 848px;
                            height: 48px;
                            background: #D0D8E6;
                            border-radius: 0px 0px 0px 0px;
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: bold;
                            font-size: 16px;
                            color: #000000;
                        }
                    }
                    .table_list{
                        height: 48px;
                        text-align: center;
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: bold;
                        font-size: 16px;
                        color: #000000;
                        border: 0;
                    }
                    .table_list_color{
                        background: #F0F2F5;
                    }
                }
                
            }
            .ls_box{
                .title_box{
                    display: flex;
                    justify-content: space-between;
                    .text_box{
                        display: flex;
                        align-items: end;
                        .title_text1{
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: bold;
                            font-size: 36px;
                            color: #333333;
                        }
                        .title_text2{
                            padding-left: 16px;
                            display: flex;
                            align-items: end;
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: 400;
                            font-size: 24px;
                            color: #377CFD;
                            img{
                                margin-left: 19px;
                                width: 28px;
                            }
                        }
                    }
                    .title_btns{
                        display: flex;
                        align-items: center;
                        .btns{
                            cursor: pointer;
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: 400;
                            font-size: 14px;
                            color: #377CFD;

                        }
                    }
                    
                }
                .ls_list{
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    padding-top: 48px;
                   
                    .item {
                        width: 458px;
                        height: 258px;
                        flex-shrink: 0;
                        background: #FFFFFF;
                        border-radius: 8px 8px 8px 8px;
                        display: flex;
                        // align-items: center;
                        padding: 32px 0 0 24px;
                        background-image: url('../../../assets/img/index/services/bg1.png');
                        background-size: 100%;

                        .item_left {
                            width: 200px;
                            display: flex;
                            flex-wrap: wrap;
                            align-content: space-between;
                            padding-right: 20px;
                            .item_left_tops {
                                width: 200px;

                                .item_title {
                                    // width: 200px;
                                    font-weight: bold;
                                    font-size: 24px;
                                    color: #333333;
                                    word-break: break-all;
                                    overflow: hidden;
                                    text-overflow: ellipsis;
                                    display: -webkit-box;
                                    -webkit-line-clamp:1;
                                    -webkit-box-orient: vertical;
                                }

                                .item_firm {
                                    font-weight: bold;
                                    font-size: 14px;
                                    color: #333333;
                                    padding-top: 10px;
                                }

                                .item_tage {
                                    padding-top: 20px;
                                    font-family: Microsoft YaHei, Microsoft YaHei;
                                    font-weight: 400;
                                    font-size: 14px;
                                    color: #666666;
                                    overflow: hidden;
                                    text-overflow: ellipsis;
                                    display: -webkit-box;
                                    -webkit-line-clamp:2;
                                    -webkit-box-orient: vertical;
                                }
                            }

                            .item_left_boms {
                                // display: flex;
                                // align-items: center;
                                padding-bottom: 30px;

                                .btns1 {
                                    width: 180px;
                                    height: 40px;
                                    background: #377CFD;
                                    border-radius: 4px 4px 4px 4px;
                                    text-align: center;
                                    line-height: 40px;
                                    cursor: pointer;
                                    font-family: Microsoft YaHei, Microsoft YaHei;
                                    font-weight: bold;
                                    font-size: 14px;
                                    color: #FFFFFF;

                                }
                            }
                        }

                        .item_right {
                            width: 224px;
                            height: 100%;
                            overflow: hidden;
                            flex-shrink: 0;

                            img {
                                width: 224px;
                            }
                        }
                    }
                }
            }
            .tjfw_box{
                padding-top: 80px;
                .title_box{
                    display: flex;
                    justify-content: space-between;
                    .text_box{
                        display: flex;
                        align-items: end;
                        .title_text1{
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: bold;
                            font-size: 36px;
                            color: #333333;
                        }
                        .title_text2{
                            padding-left: 16px;
                            display: flex;
                            align-items: end;
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: 400;
                            font-size: 24px;
                            color: #377CFD;
                            img{
                                margin-left: 19px;
                                width: 28px;
                            }
                        }
                    }
                    .title_btns{
                        display: flex;
                        align-items: center;
                        .btns{
                            cursor: pointer;
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: 400;
                            font-size: 14px;
                            color: #377CFD;

                        }
                    }
                    
                }
                .tjfw_list{
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    padding-top: 48px;
                    flex-wrap: wrap;
                    .item2{
                        width: 330px;
                    }
                    .item{
                        width: 330px;
                        height: 425px;
                        background: #FFFFFF;
                        border-radius: 0px 0px 0px 0px;
                        border: 1px solid #D7D7D7;
                        .item_img{
                            width: 330px;
                            height: 260px;
                            img{
                                width: 330px;
                                height: 260px;
                            }
                        }
                        .item_info{
                            padding: 24px 20px;
                            .item_title{
                                font-family: Microsoft YaHei, Microsoft YaHei;
                                font-weight: bold;
                                font-size: 18px;
                                color: #333333;
                            }
                            .item_tages{
                                display: flex;
                                align-items: center;
                                flex-wrap: wrap;
                                padding-top: 16px;
                                min-height: 30px;
                                .tages{
                                    padding: 4px 12px;
                                    background: #FDF6EC;
                                    border-radius: 3px 3px 3px 3px;
                                    border: 1px solid #FFAA00;
                                    font-family: Microsoft YaHei, Microsoft YaHei;
                                    font-weight: 400;
                                    font-size: 12px;
                                    color: #FFAA00;
                                    margin-right: 10px;
                                }

                            }
                            .item_price{
                                padding-top: 20px;
                                display: flex;
                                // align-items: center;
                                align-items: end;
                                justify-content: space-between;
                                .prices{
                                    font-family: Microsoft YaHei, Microsoft YaHei;
                                    font-weight: bold;
                                    font-size: 28px;
                                    color: #FD4C5C;

                                }
                                .nums{
                                    font-family: Microsoft YaHei, Microsoft YaHei;
                                    font-weight: 400;
                                    font-size: 14px;
                                    color: #999999;
                                }
                            }

                        }
                    }
                }
            }

        }
		 

	}
</style>
<style scoped lang="less">
@import "../../../styles/mobile-patterns.less";

@media (max-width: 1024px) {
    .service.no-trans {
        max-width: 100%;
        min-width: 0;
        font-size: 14px;
        line-height: 1.6;
        padding-bottom: 16px;
    }
    .service.no-trans .banners {
        min-height: 0;
        height: auto;
    }
    .service.no-trans .banners img {
        min-height: 0;
        height: auto;
    }
    .service.no-trans .service_box {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        margin: auto;
    }
    .service.no-trans .service_box .type_list {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        min-height: 0;
        height: auto;
        border-radius: 8px 8px 8px 8px;
        margin: auto;
        margin-top: -16px;
        flex-wrap: wrap;
        gap: 8px;
    }
    .service.no-trans .service_box .type_list .type_item {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
    }
    .service.no-trans .service_box .type_list .type_item .items {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        min-height: 0;
        height: auto;
        flex-wrap: wrap;
        gap: 8px;
    }
    .service.no-trans .service_box .type_list .type_item .items .item_img {
        width: 48px;
    }
    .service.no-trans .service_box .type_list .type_item .items .item_img img {
        width: 48px;
    }
    .service.no-trans .service_box .type_list .type_item .items .item_info {
        padding-left: 16px;
    }
    .service.no-trans .service_box .type_list .type_item .items .item_info .item_title {
        font-size: 20px;
    }
    .service.no-trans .service_box .type_list .type_item .items .item_info .item_text {
        font-size: 14px;
        margin-top: 12px;
    }
    .service.no-trans .service_box .type_list .type_item .type_borders {
        width: 1px;
        height: 56px;
    }
    .service.no-trans .service_box .type_box {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        margin-top: 16px;
    }
    .service.no-trans .service_box .type_box .type_lefts {
        padding-top: 16px;
    }
    .service.no-trans .service_box .type_box .type_lefts .left_title {
        font-size: 20px;
        margin-bottom: 16px;
    }
    .service.no-trans .service_box .type_box .type_lefts .form_flex {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        margin-bottom: 16px;
        flex-direction: column;
        align-items: stretch;
    }
    .service.no-trans .service_box .type_box .type_lefts .form_flex .form_title {
        font-size: 14px;
        padding-right: 16px;
        width: 100%;
        text-align: left;
        line-height: 1.6;
        padding: 0;
    }
    .service.no-trans .service_box .type_box .type_lefts .form_flex .form_input1 {
        max-width: 100%;
        min-width: 0;
        width: 100%;
    }
    .service.no-trans .service_box .type_box .type_lefts .form_flex .form_input1 /deep/ .el-select {
        max-width: 100%;
        min-width: 0;
        width: 100%;
    }
    .service.no-trans .service_box .type_box .type_lefts .form_flex .form_input2 {
        max-width: 100%;
        min-width: 0;
        width: 100%;
    }
    .service.no-trans .service_box .type_box .type_lefts .form_flex .form_input2 /deep/ .el-input .el-input__suffix {
        padding: 0 5px;
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
    }
    .service.no-trans .service_box .type_box .type_lefts .form_flex .form_input3 {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        margin-top: 16px;
        max-width: 100%;
    }
    .service.no-trans .service_box .type_box .type_lefts .form_flex .form_input3 .btns1 {
        width: 134px;
        height: auto;
        border-radius: 4px 4px 4px 4px;
        line-height: 1.6;
        font-size: 14px;
        min-height: 44px;
        padding-top: 12px;
        padding-bottom: 12px;
    }
    .service.no-trans .service_box .type_box .type_lefts .form_flex .form_input3 .btns2 {
        width: 134px;
        height: auto;
        border-radius: 4px 4px 4px 4px;
        line-height: 1.6;
        font-size: 14px;
        margin-left: 10px;
        min-height: 44px;
        padding-top: 12px;
        padding-bottom: 12px;
    }
    .service.no-trans .service_box .type_box .type_border {
        width: 1px;
        min-height: 0;
        height: auto;
        border-radius: 4px 4px 4px 4px;
    }
    .service.no-trans .service_box .type_box .type_rights {
        padding-top: 16px;
    }
    .service.no-trans .service_box .type_box .type_rights .price_title {
        font-size: 20px;
        margin: auto;
    }
    .service.no-trans .service_box .type_box .type_rights .price_box1 {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        min-height: 0;
        height: auto;
        border-radius: 4px 4px 4px 4px;
        margin: auto;
        margin-top: 16px;
        flex-wrap: wrap;
        gap: 8px;
    }
    .service.no-trans .service_box .type_box .type_rights .price_box1 .span1 {
        font-size: 24px;
    }
    .service.no-trans .service_box .type_box .type_rights .price_box1 .span2 {
        font-size: 24px;
        margin-left: 10px;
    }
    .service.no-trans .service_box .type_box .type_rights .price_box2 {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        height: auto;
        border-radius: 4px 4px 4px 4px;
        margin: auto;
        margin-top: 16px;
        flex-wrap: wrap;
        gap: 8px;
        padding: 0 16px;
        min-height: 40px;
    }
    .service.no-trans .service_box .type_box .type_rights .price_box2 .text1 {
        font-size: 14px;
    }
    .service.no-trans .service_box .type_box .type_rights .price_box2 .text2 {
        font-size: 14px;
    }
    .service.no-trans .service_box .type_box .type_rights .price_box3 {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        height: auto;
        border-radius: 4px 4px 4px 4px;
        margin: auto;
        margin-top: 16px;
        flex-wrap: wrap;
        gap: 8px;
        padding: 0 16px;
        min-height: 40px;
    }
    .service.no-trans .service_box .type_box .type_rights .price_box3 .text1 {
        font-size: 14px;
    }
    .service.no-trans .service_box .type_box .type_rights .price_box3 .text2 {
        font-size: 14px;
    }
    .service.no-trans .service_box .type_box .type_rights .price_box4 {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        margin: auto;
        margin-top: 16px;
        font-size: 14px;
    }
    .service.no-trans .service_box .type_box2 {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        margin: auto;
        margin-top: 16px;
        margin-bottom: 16px;
    }
    .service.no-trans .service_box .type_box2 .type_table .type_header .td1 {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        height: 48px;
        border-radius: 0px 0px 0px 0px;
        font-size: 16px;
    }
    .service.no-trans .service_box .type_box2 .type_table .type_header .td2 {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        height: 48px;
        border-radius: 0px 0px 0px 0px;
        font-size: 16px;
    }
    .service.no-trans .service_box .type_box2 .type_table .table_list {
        height: 48px;
        font-size: 16px;
    }
    .service.no-trans .service_box .ls_box .title_box {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
    }
    .service.no-trans .service_box .ls_box .title_box .text_box {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
    }
    .service.no-trans .service_box .ls_box .title_box .text_box .title_text1 {
        font-size: 24px;
    }
    .service.no-trans .service_box .ls_box .title_box .text_box .title_text2 {
        padding-left: 16px;
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        font-size: 24px;
    }
    .service.no-trans .service_box .ls_box .title_box .text_box .title_text2 img {
        margin-left: 16px;
        width: 28px;
    }
    .service.no-trans .service_box .ls_box .title_box .title_btns {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
    }
    .service.no-trans .service_box .ls_box .title_box .title_btns .btns {
        font-size: 14px;
        min-height: 44px;
        height: auto;
        line-height: 1.6;
        padding-top: 12px;
        padding-bottom: 12px;
    }
    .service.no-trans .service_box .ls_box .ls_list {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        padding-top: 16px;
    }
    .service.no-trans .service_box .ls_box .ls_list .item {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        min-height: 0;
        height: auto;
        border-radius: 8px 8px 8px 8px;
        flex-wrap: wrap;
        gap: 8px;
        padding: 16px 0 0 16px;
    }
    .service.no-trans .service_box .ls_box .ls_list .item .item_left {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        flex-wrap: wrap;
        gap: 8px;
        padding-right: 16px;
    }
    .service.no-trans .service_box .ls_box .ls_list .item .item_left .item_left_tops {
        max-width: 100%;
        min-width: 0;
        width: 100%;
    }
    .service.no-trans .service_box .ls_box .ls_list .item .item_left .item_left_tops .item_title {
        font-size: 24px;
    }
    .service.no-trans .service_box .ls_box .ls_list .item .item_left .item_left_tops .item_firm {
        font-size: 14px;
        padding-top: 10px;
    }
    .service.no-trans .service_box .ls_box .ls_list .item .item_left .item_left_tops .item_tage {
        padding-top: 16px;
        font-size: 14px;
    }
    .service.no-trans .service_box .ls_box .ls_list .item .item_left .item_left_boms {
        padding-bottom: 16px;
    }
    .service.no-trans .service_box .ls_box .ls_list .item .item_left .item_left_boms .btns1 {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        height: auto;
        border-radius: 4px 4px 4px 4px;
        line-height: 1.6;
        font-size: 14px;
        min-height: 44px;
        padding-top: 12px;
        padding-bottom: 12px;
    }
    .service.no-trans .service_box .ls_box .ls_list .item .item_right {
        max-width: 100%;
        min-width: 0;
        width: 100%;
    }
    .service.no-trans .service_box .ls_box .ls_list .item .item_right img {
        max-width: 100%;
        min-width: 0;
        height: auto;
        width: 100%;
    }
    .service.no-trans .service_box .tjfw_box {
        padding-top: 16px;
    }
    .service.no-trans .service_box .tjfw_box .title_box {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
    }
    .service.no-trans .service_box .tjfw_box .title_box .text_box {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
    }
    .service.no-trans .service_box .tjfw_box .title_box .text_box .title_text1 {
        font-size: 24px;
    }
    .service.no-trans .service_box .tjfw_box .title_box .text_box .title_text2 {
        padding-left: 16px;
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        font-size: 24px;
    }
    .service.no-trans .service_box .tjfw_box .title_box .text_box .title_text2 img {
        margin-left: 16px;
        width: 28px;
    }
    .service.no-trans .service_box .tjfw_box .title_box .title_btns {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
    }
    .service.no-trans .service_box .tjfw_box .title_box .title_btns .btns {
        font-size: 14px;
        min-height: 44px;
        height: auto;
        line-height: 1.6;
        padding-top: 12px;
        padding-bottom: 12px;
    }
    .service.no-trans .service_box .tjfw_box .tjfw_list {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        padding-top: 16px;
    }
    .service.no-trans .service_box .tjfw_box .tjfw_list .item2 {
        max-width: 100%;
        min-width: 0;
        width: 100%;
    }
    .service.no-trans .service_box .tjfw_box .tjfw_list .item {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        min-height: 0;
        height: auto;
        border-radius: 0px 0px 0px 0px;
    }
    .service.no-trans .service_box .tjfw_box .tjfw_list .item .item_img {
        max-width: 100%;
        min-width: 0;
        height: auto;
        width: 100%;
        min-height: 0;
    }
    .service.no-trans .service_box .tjfw_box .tjfw_list .item .item_img img {
        max-width: 100%;
        min-width: 0;
        height: auto;
        width: 100%;
        min-height: 0;
    }
    .service.no-trans .service_box .tjfw_box .tjfw_list .item .item_info {
        padding: 16px 16px;
    }
    .service.no-trans .service_box .tjfw_box .tjfw_list .item .item_info .item_title {
        font-size: 18px;
    }
    .service.no-trans .service_box .tjfw_box .tjfw_list .item .item_info .item_tages {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        padding-top: 16px;
    }
    .service.no-trans .service_box .tjfw_box .tjfw_list .item .item_info .item_tages .tages {
        padding: 4px 12px;
        border-radius: 3px 3px 3px 3px;
        font-size: 14px;
        margin-right: 10px;
    }
    .service.no-trans .service_box .tjfw_box .tjfw_list .item .item_info .item_price {
        padding-top: 16px;
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
    }
    .service.no-trans .service_box .tjfw_box .tjfw_list .item .item_info .item_price .prices {
        font-size: 24px;
    }
    .service.no-trans .service_box .tjfw_box .tjfw_list .item .item_info .item_price .nums {
        font-size: 14px;
    }
}

@media (max-width: 1024px) {
    .service.no-trans .service_box .ls_box .title_box { .mobile-section-heading(); }
    .service.no-trans .service_box .tjfw_box .title_box { .mobile-section-heading(); }
    .service.no-trans .service_box {
        padding: 0 16px 24px;
        .type_list {
            display: grid; grid-template-columns: repeat(3, minmax(0, 1fr)); gap: 8px; margin: 16px 0 24px; padding: 0; box-shadow: none;
            .type_item {
                width: 100%; padding: 0;
                .items { display: flex; flex-direction: column; align-items: center; justify-content: center; gap: 8px; min-height: 112px; padding: 12px 6px; border: 1px solid #e5eaf0; border-radius: 6px; }
                .items .item_img, .items .item_img img { width: 28px; height: 28px; }
                .items .item_info { padding: 0; }
                .items .item_info .item_title { font-size: 14px; line-height: 22px; text-align: center; }
                .items .item_info .item_text, .type_borders { display: none; }
                &.type_ac .items { background: #edf3ff; border-color: #377cfd; }
            }
        }
        .type_box { flex-direction: column; align-items: stretch; padding: 0; }
        .type_box .type_lefts .form_flex .form_input2 /deep/ .el-input .el-input__suffix { font-size: 14px; line-height: 44px; }
        .type_box .type_border { display: none; }
        .ls_box { padding-top: 24px; }
        .ls_box .ls_list {
            display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 12px;
            .item { display: flex; flex-direction: column-reverse; gap: 0; padding: 0; overflow: hidden; border: 1px solid #e5eaf0; border-radius: 6px; }
            .item .item_right { height: auto; aspect-ratio: ~"3 / 4"; overflow: hidden; }
            .item .item_right img { display: block; width: 100%; height: 100%; object-fit: cover; object-position: top; }
            .item .item_left { padding: 12px; }
            .item .item_left .item_left_tops .item_title { font-size: 17px; line-height: 26px; }
            .item .item_left .item_left_tops .item_firm { font-size: 13px; padding-top: 4px; }
            .item .item_left .item_left_tops .item_tage { font-size: 13px; padding-top: 8px; }
            .item .item_left .item_left_boms { width: 100%; padding: 12px 0 0; }
            .item .item_left .item_left_boms .btns1 { padding: 10px 6px; min-height: 44px; line-height: 24px; }
        }
        .tjfw_box { padding-top: 24px; }
        .tjfw_box .tjfw_list {
            display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 12px; align-items: start;
            .item2 { display: none; }
            .item { width: 100%; border: 1px solid #e5eaf0; border-radius: 6px; overflow: hidden; }
            .item .item_img { height: auto; aspect-ratio: ~"4 / 3"; background: #f1f5f9; }
            .item .item_img img { display: block; height: 100%; object-fit: cover; }
            .item .item_info { padding: 12px; }
            .item .item_info .item_title { font-size: 15px; line-height: 24px; }
            .item .item_info .item_tages { padding-top: 8px; .tages { margin: 0; padding: 2px 6px; font-size: 13px; } }
            .item .item_info .item_price { padding-top: 12px; .prices { font-size: 18px; } .nums { font-size: 13px; } }
        }
    }
}
@media (min-width: 769px) and (max-width: 1024px) {
    .service.no-trans .service_box .ls_box .ls_list,
    .service.no-trans .service_box .tjfw_box .tjfw_list { grid-template-columns: repeat(4, minmax(0, 1fr)); }
}
@media (max-width: 1024px) {
    .service.no-trans {
        padding-bottom: 24px;
        .banners { height: auto; }
        .banners img { display: block; width: 100%; height: auto; }
        .service_box {
            box-sizing: border-box;
            .type_list {
                height: auto; margin: 16px 0 20px; align-items: stretch;
                .type_item .items { box-sizing: border-box; height: 100%; min-height: 88px; padding: 10px 4px; gap: 6px; border-radius: 4px; }
                .type_item .items .item_info .item_title { font-size: 13px; line-height: 20px; overflow-wrap: anywhere; }
                .type_item .items .item_img, .type_item .items .item_img img { width: 24px; height: 24px; }
            }
            .type_box {
                gap: 20px;
                .type_lefts {
                    width: 100%;
                    .left_title { margin: 0; padding: 0 0 16px; font-size: 18px; line-height: 26px; font-weight: 600; }
                    .form_flex { display: grid; grid-template-columns: 64px minmax(0, 1fr); align-items: center; gap: 8px; margin-bottom: 16px; }
                    .form_flex .form_title { width: auto; margin: 0; padding: 0; font-size: 14px; line-height: 24px; }
                    .form_flex .form_input1, .form_flex .form_input2 { width: 100%; min-width: 0; }
                    .form_flex /deep/ .el-select { width: 100%; }
                    .form_flex /deep/ .el-input__inner { height: 46px; line-height: 46px; padding-left: 12px; font-size: 16px; border-radius: 4px; border-color: #dfe5ee; }
                    .form_flex /deep/ .el-input__icon { line-height: 46px; }
                    .form_flex .form_input2 /deep/ .el-input__suffix { right: 12px; line-height: 46px; font-size: 14px; }
                    .form_flex .form_title:empty { display: none; }
                    .form_flex .form_input3 { grid-column: ~"1 / -1"; display: grid; grid-template-columns: 1fr 1fr; gap: 12px; padding-top: 4px; }
                    .form_flex .form_input3 .btns1, .form_flex .form_input3 .btns2 { box-sizing: border-box; width: 100%; min-width: 0; height: 46px; margin: 0; padding: 0 6px; line-height: 44px; font-size: 15px; border-radius: 4px; }
                }
                .type_rights {
                    box-sizing: border-box; width: 100%; padding: 18px 16px; background: #f5f8fc; border-radius: 4px;
                    .price_title { font-size: 16px; font-weight: 600; line-height: 24px; }
                    .price_box1 { justify-content: flex-start; gap: 6px; min-height: 0; height: auto; padding: 14px 0; margin: 0; background: transparent; }
                    .price_box1 .span1 { font-size: 32px; font-weight: 600; line-height: 42px; overflow-wrap: anywhere; }
                    .price_box1 .span2 { font-size: 14px; }
                    .price_box2, .price_box3 { display: grid; grid-template-columns: 58px minmax(0, 1fr); align-items: start; gap: 12px; height: auto; min-height: 0; padding: 10px 0; margin: 0; background: transparent; }
                    .price_box2 .text1, .price_box3 .text1 { font-size: 13px; line-height: 24px; color: #7b8491; }
                    .price_box2 .text2, .price_box3 .text2 { min-width: 0; font-size: 14px; line-height: 24px; overflow-wrap: anywhere; }
                    .price_box4 { padding-top: 12px; margin-top: 6px; border-top: 1px solid #e3e9f2; font-size: 13px; line-height: 23px; color: #7b8491; }
                }
            }
            .ls_box .title_box, .tjfw_box .title_box { flex-wrap: nowrap; gap: 8px; }
            .ls_box .title_box .text_box .title_text2, .tjfw_box .title_box .text_box .title_text2 { display: none; }
            .ls_box .ls_list {
                grid-template-columns: minmax(0, 1fr);
                .item { display: grid; grid-template-columns: minmax(0, 1fr) 80px; align-items: center; gap: 12px; padding: 14px; border-radius: 4px; }
                .item .item_right { width: 80px; height: 100px; aspect-ratio: ~"4 / 5"; border-radius: 4px; }
                .item .item_left { min-width: 0; width: 100%; padding: 0; }
                .item .item_left .item_left_tops .item_firm, .item .item_left .item_left_tops .item_tage { overflow-wrap: anywhere; line-height: 21px; }
                .item .item_left .item_left_boms { padding-top: 8px; }
                .item .item_left .item_left_boms .btns1 { box-sizing: border-box; width: 100%; padding: 0 8px; height: 44px; line-height: 44px; }
            }
            .tjfw_box .tjfw_list {
                align-items: stretch;
                .item .item_info { padding: 10px; }
                .item .item_info .item_title { height: 48px; overflow: hidden; display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; overflow-wrap: anywhere; }
                .item .item_info .item_tages { max-height: 30px; overflow: hidden; }
                .item .item_info .item_price { gap: 4px; align-items: flex-start; flex-direction: column; }
            }
        }
        [role="button"]:focus-visible { outline: 2px solid #377cfd; outline-offset: -2px; }
    }
}
</style>
